/**
 * @file The `salesClosedTotal` and `salesClosedByMonth` column a booked figure reads at each scope level:
 * sales credit at My sales, where the goal counts each credit owner's share, and the whole
 * booked amount at My team and Org. Consumers: `writeHomeSummaries` for the home summary's `booked`, and
 * the Overview booked tile, goal and month chart, so Home and the Overview read one column per level.
 */
import type { AnalyticsScopeLevel } from './Analytics.NamedQuery.types';

export const ANALYTICS_BOOKED_COLUMN = { self: 'creditAmount', team: 'amount', org: 'amount' } as const satisfies Record<AnalyticsScopeLevel, 'amount' | 'creditAmount'>;
